import createCanvas from './createCanvas';

const clip = ({
    content,
    line,
    ellips,
    addonWidth,
    wrapWitdth,
    fontStyle,
    fontVariant,
    fontWeight,
    fontSize,
    lineHeight,
    fontFamily,
}) => {
    // 单例的canvas dom对象
    const cvs = createCanvas();
    // 获取canvas的上下文
    const ctx = cvs.getContext('2d');

    // 设置canvas上下文的字体
    ctx.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`;

    // 用于循环的文本字符串，初始值为传入的content
    let text = content;
    // 循环的终止条件
    let flag = true;
    // 每一行的文本，初始值为空字符串
    let clipText = '';
    // 存储各行文本的数组
    const lineArr = [];
    // 最终返回的文本字符串
    let finalText = '';
    // 用于返回文本是否超出行数限制
    let overflow = false;

    while (flag) {
        // 将当前行文本clipText加上一个字符
        const newClipText = clipText + text?.slice(0, 1);

        let width = 0;

        if (lineArr.length + 1 >= line) {
            // 如果是最后一行
            // 计算canvas文字宽度的时候加上省略符
            const ctxWidth =
                text?.slice(0, 1) === '\n'
                    ? wrapWitdth + ctx.measureText(clipText + ellips).width
                    : ctx.measureText(newClipText + ellips).width;

            // 计算宽度的时候加上addOn的宽度
            width = lineArr.length + 1 >= line ? ctxWidth + addonWidth : ctxWidth;
        } else {
            width =
                text?.slice(0, 1) === '\n'
                    ? wrapWitdth + ctx.measureText(clipText).width
                    : ctx.measureText(newClipText).width;
        }

        if (width > wrapWitdth) {
            // 如果已经是限定的最后一行了
            // https://blog.csdn.net/cysear/article/details/80435756
            const reg = /[\u3002|\u2026|\uff0c|\uff1f|\uff1a|\u201d|\uff09|\u3009|\u300b|\u300d|\u300f|\ufe44|\u3015|\u3001|\u3011|\u3002|\uff01|\uff1b|\u2019]/gi;

            if (text?.slice(0, 1) === '\n') {
                lineArr.push(newClipText);
                text = text?.slice(1, text.length);
            } else if (reg.test(text?.slice(0, 1))) {
                text = clipText?.slice(clipText.length - 1, clipText.length) + text;
                lineArr.push(clipText?.slice(0, clipText.length - 1));
            } else {
                // 判断当前行长度是否大于文本容器的宽度
                // 如果超出，那么当前行已经完成，把没有加上一个字符的当前行文本clipText放入存储各行文本的数组lineArr
                lineArr.push(clipText);
            }
            // 重置当前行文本clipText
            clipText = '';
        } else {
            clipText = newClipText;
            text = text?.slice(1, text.length);
        }

        if (lineArr.length >= line) {
            // 终止循环
            flag = false;
            finalText = lineArr.join('') + ellips;
            overflow = true;
        }

        // 如果原始文本都遍历完了还没有结束，证明原始文本长度小于限制条件，直接返回原始文本
        if (flag && text.length === 0) {
            flag = false;
            finalText = content;
        }
    }

    return { text: finalText, overflow, line: lineArr.length + 1 };
};

export default clip;
